import React, { FC, Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

// Components
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { QuickViewCategoryParagraph_item } from './__generated__/QuickViewCategoryParagraph_item.graphql';
import { QuickViewCategoryParagraph_itemSearch } from './__generated__/QuickViewCategoryParagraph_itemSearch.graphql';
import { PAGE_TYPE, BROWSE_TYPES } from 'dibs-constants/exports/pageTypes';

type QuickViewCategoryParagraphProps = {
    item: QuickViewCategoryParagraph_item;
    itemSearch: QuickViewCategoryParagraph_itemSearch;
    attributes: string;
    paragraphClassName: string;
    categoryClassName: string;
};

type CategorySegmentsType =
    | {
          period: string | null;
          origin: string | null;
          style: string | null;
          periodPrefix: string | null;
      }
    | null
    | undefined;

export const whitelistedPageTypes = BROWSE_TYPES.filter(type => type !== PAGE_TYPE.BUY);

export const copy = {
    category: (
        <FormattedMessage id="dc.searchProductTile.category" defaultMessage="Category">
            {msg => <Fragment>{msg}</Fragment>}
        </FormattedMessage>
    ),
};

const QuickViewCategoryParagraph: FC<QuickViewCategoryParagraphProps> = ({
    item,
    itemSearch,
    attributes,
    paragraphClassName,
    categoryClassName,
}) => {
    const pageHeading = itemSearch?.meta?.header;
    const pageType = itemSearch?.pageType;
    const categorySegments: CategorySegmentsType = item?.quickViewDisplay?.paragraphAttributeNames;
    let category: string | undefined;

    if (categorySegments && pageType && whitelistedPageTypes.includes(pageType)) {
        const filteredCategorySegments = Object.entries(categorySegments)
            // GROWTH-5337: remove segment if it matches pageType
            .filter(([key]) => key !== pageType)
            .map(([, value]) => value);

        category = [...filteredCategorySegments, pageHeading].join(' ');
    }

    if (!category && !attributes) {
        return null;
    }

    return (
        <HeadingLevel>
            {Heading => (
                <div className={paragraphClassName}>
                    {copy.category}
                    <Heading className={categoryClassName}>{category || attributes}</Heading>
                </div>
            )}
        </HeadingLevel>
    );
};

export default createFragmentContainer(QuickViewCategoryParagraph, {
    itemSearch: graphql`
        fragment QuickViewCategoryParagraph_itemSearch on ItemSearchQueryConnection {
            meta {
                header
            }
            pageType
        }
    `,
    item: graphql`
        fragment QuickViewCategoryParagraph_item on Item {
            quickViewDisplay {
                paragraphAttributeNames {
                    period
                    origin
                    style
                    periodPrefix
                }
            }
        }
    `,
});
